import * as React from "react";
import {Grid} from "@material-ui/core";
import styled from "styled-components";
import {Colors} from "../../theme/colors";

export const DetailsWrapper: React.FC<Props> = ({children, description}) => (
    <StyledWrapper container direction={"column"} spacing={2}>
        <Grid item>
            <StyledP>{description}</StyledP>
        </Grid>
        <StyledContent item>
            {children}
        </StyledContent>
    </StyledWrapper>
);

const StyledWrapper = styled(Grid)`
  padding: 0 1rem;
`;

const StyledP = styled('p')`
  color: ${Colors.grayText};
  font-size: 0.9rem;
  margin-top: 1rem;
`;

const StyledContent = styled(Grid)`
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #E0E0E0;
  border-radius: 4px;
  margin-top: 2rem;
  position: relative;
`;

interface Props {
    description?: string;
}
